import { createFileRoute } from '@tanstack/react-router'
import node, {
  type proposalPageEditorQuery,
} from '#gen/relay/proposalPageEditorQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/proposals/$id/_proposal/editor',
)({
  staticData: { title: '[graph] - Proposal Editor' },
  loader({ context, params }) {
    return context.preload<proposalPageEditorQuery>(node, {
      proposalId: params.id,
    })
  },
  component: lazyLoadedComponent(
    () =>
      import(
        '#app/pages/branch/proposals/proposal-page/editor-page/proposal-page-editor'
      ),
    'ProposalPageEditor',
  ),
})
